import { render, staticRenderFns } from "./receivableWriteOff.vue?vue&type=template&id=3a83bc81&scoped=true&"
import script from "./receivableWriteOff.vue?vue&type=script&lang=js&"
export * from "./receivableWriteOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83bc81",
  null
  
)

export default component.exports